import { Box } from '@mui/material'

type DriversPlanIconProps = {
  showPlus?: boolean
  size?: number
}

const DriversPlanIcon = ({ showPlus = false, size = 92 }: DriversPlanIconProps) => (
  <Box sx={{ position: 'relative', width: size, height: size, mx: size === 92 ? 'auto' : 0 }}>
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'linear-gradient(180deg, #e8f3fc 0%, #d5e9f8 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width={size * 0.7}
        height={size * 0.48}
        viewBox="0 0 64 44"
        fill="none"
        aria-hidden
      >
        <circle cx="18" cy="12" r="7" fill="#0a57a8" />
        <rect x="8" y="20" width="20" height="18" rx="6" fill="#1a7ad4" />
        <circle cx="32" cy="10" r="8" fill="#0a57a8" />
        <rect x="21" y="19" width="22" height="20" rx="7" fill="#0a57a8" />
        <circle cx="46" cy="12" r="7" fill="#0a57a8" />
        <rect x="36" y="20" width="20" height="18" rx="6" fill="#1a7ad4" />
      </svg>
    </Box>
    {showPlus && (
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: 28,
          height: 28,
          borderRadius: '50%',
          bgcolor: '#22c55e',
          color: '#fff',
          fontWeight: 700,
          fontSize: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '3px solid #fff',
        }}
      >
        +
      </Box>
    )}
  </Box>
)

export default DriversPlanIcon
